import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import { addToWishlist } from "../../redux/wishlistReducer";

const Card = ({ item }) => {
    const favs = useSelector((state) => state.wishlist.products);
    const navigate = useNavigate();
    const [selectedList, setSelectedList] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        favs?.find((data) => item.id === data.id) ? setSelectedList(true) : setSelectedList(false)
      }, [item, favs]);
    return (
        <div className="col-md-4">
            <div className="card mb-4 product-wap rounded-0">
                <div className="card rounded-0">
                    {item.isNew === 1 ? <span className="newMark bg-dark">New</span> : <></>}
                    <img className="card-img rounded-0 img-fluid" src={process.env.REACT_APP_UPLOAD_URL + item.img[0]?.image} alt="" />
                    <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                            <li style={item.isImgReq || item.isMsgReq ? {display: "none"} : {}}><Link onClick={() => {
                                dispatch(
                                    addToWishlist({
                                        id: item.id,
                                        title: item.title,
                                        title_slug: item.title_slug,
                                        description: item.description,
                                        price: item.price,
                                        img: item.img[0].image,
                                        quantity: 1,
                                        file: "",
                                        fileId: "0",
                                        message: "",
                                    })
                                );
                                setSelectedList(true);
                                }} className="btn btn-success text-white">{!selectedList ? <i className="far fa-heart" /> : <i className="far fa-heart text-dark" />}</Link></li>
                            <li><Link to={`/product/${item.title_slug}`} className="btn btn-success text-white mt-2"><i className="far fa-eye"></i></Link></li>
                            <li style={item.isImgReq || item.isMsgReq ? {display: "none"} : {}}><Link onClick={() =>
                                dispatch(
                                    addToCart({
                                        id: item.id,
                                        title: item.title,
                                        title_slug: item.title_slug,
                                        description: item.description,
                                        price: item.price,
                                        img: item.img[0].image,
                                        quantity: item.quantity,
                                        file: "",
                                        fileId: "0",
                                        message: "",
                                    })
                                ) && navigate("/cart", { replace: true }
                                )} className="btn btn-success text-white mt-2"><i className="fas fa-cart-plus"></i></Link></li>
                        </ul>
                    </div>
                </div>
                <div className="card-body card-dtls">
                    <Link to={`/product/${item.title_slug}`} className="card-title text-decoration-none text-dark">{item.title}</Link>
                    {/*<p className="card-text card-desc">
                        {item.description.length > 49 ? 
                        <ReactMarkdown>{item.description.substring(0, 48) + "..."}</ReactMarkdown> : 
                        <ReactMarkdown>{item.description}</ReactMarkdown>}
                    </p>*/}
                    <p className="text-center mb-0 mt-3">₹ {item.price}</p>
                </div>
            </div>
        </div>
    );
};

export default Card;
